import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import React from 'react'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './MissingKeywordsModal.module.scss'

export const MissingKeywordsModal = ({ add, skip }: any) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className={clsx(styles.root)}>
      <p className={clsx(styles.title)}>{t('pages.project.missingKeywords')}</p>
      <p className={clsx(styles.message)}>
        {t('pages.project.yourLocationsMissingKeywords')}
      </p>
      <div className={clsx(styles.buttons)}>
        <BpButton
          className={clsx(styles.button)}
          onClick={() => {
            dispatch(hideModal())
            add && add()
          }}
        >
          {t('buttons.addKeywords')}
        </BpButton>
        <BpButton
          className={clsx(styles.button)}
          theme={'outline'}
          onClick={() => {
            dispatch(hideModal())
            skip && skip()
          }}
        >
          {t('buttons.skipForNow')}
        </BpButton>
      </div>
    </div>
  )
}
